import { Keyboard, KeyboardAvoidingView, Platform, Pressable, StatusBar, Text, TextInput, View } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { SafeAreaView } from 'react-native-safe-area-context'

import { verifyEmail } from "../../../services/Auth/authService";
import AuthIcons from "../../../assets/Icons/AuthIcons";
import CustomComponent from "../../../components/CustomComponent";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { styles } from "../auth.style";
import TopIconView from "../components/TopIconView";
import BottomView from "../../../components/GlobalComponents/BottomView";
import { Colors } from "../../../globalStyles/ColorConfig";

const MailAuth = ({ navigation }: { navigation: any }) => {
  //   const navigation = useNavigation();
  const [mail, setMail] = useState("");
  const [mailError, setMailError] = useState(false);
  const [mailErrorTitle, setMailErrorTitle] = useState('');

  const handleMailTextChange = (text: string) => {
    setMail(text);
    setMailError(false);
  };

  const checkNewUser = async () => {
    try {
      const credentials = {
        email: mail,
      };
      const response = await verifyEmail(credentials);
      if (response?.data?.message == "Email already exists!" && !response?.data?.unique && response.status == 200) {
        
        navigation.navigate("auth-password", { mail });
      } else {
        navigation.navigate("auth-setpassword", { mail, navigation });
      }
    } catch (error) {
      console.error("Error checking new user:", error);
    }
  };

  const validateMail = () => {
    if(!mail){
      setMailErrorTitle('This field is required!');
      setMailError(true);
      return false;
    }
    var mailFormat = /\S+@\S+\.\S+/;
    if (mail.match(mailFormat)) {
      setMailError(false);
      return true
    } else {
      setMailErrorTitle('Invalid e-mail address!')
      setMailError(true);
      return false
    }
  };
  


  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const inputRef = useRef<TextInput>(null); 

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
        <Pressable onPress={Keyboard.dismiss} style={{flex: 1}}>
          <View style={styles.mobileAuthView}>
            <TopIconView icon={<AuthIcons.MessageIconDark />} />
            <CustomComponent.TextView
              title="What’s your e-mail id?"
              textStyle={GlobalStyles.heading3}
            />
            <CustomComponent.TextView
              title="We protect our community by making sure everyone on Spark is real"
              textStyle={GlobalStyles.bodyText}
            />
            <View style={{width: '100%', height: 60}}>
              <CustomComponent.InputField
                error={mailError}
                ref={inputRef}
                placeholder="Type your e-mail id"
                keyboardtype="email-address"
                onTextChange={handleMailTextChange}
                InputStyle={[GlobalStyles.title2]}
              />
            </View>
            {
              mailError && (
                <Text style={[GlobalStyles.captionText,{
                  color: Colors.red10,
                }]}>
                  {mailErrorTitle}
                </Text>
              )
            }
          </View>
          <BottomView
            disableBtn={true}
            onPress={()=> validateMail() && checkNewUser()}
            bottomTitle="We never share this with anyone and it won’t be on your profile"
            style={{paddingBottom: 20}}
          />
        </Pressable>
    </SafeAreaView>
  );
};

export default MailAuth;
